import { ButtonBase } from '@pets-ui/ButtonBase/ButtonBase'
import { Image } from '@pets-ui/Image/Image'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const styles = stylex.create({
  root: {
    borderColor: colors.grey300,
    borderStyle: 'solid',
    borderWidth: 1,
  },
  selectedMedium: {
    borderColor: colors.red600,
    boxShadow: '0px 0px 8px 0px rgba(255, 199, 0, 0.6)',
  },
  selectedSmall: {
    borderColor: colors.red600,
    boxShadow: '0px 0px 6px 0px rgba(255, 199, 0, 0.6)',
  },
})

const sizeMap = {
  medium: { width: 168, height: 60, imageWidth: 112, imageHeight: 44, borderRadius: 8, selectedStyle: styles.selectedMedium },
  small: { width: 120, height: 43, imageWidth: 80, imageHeight: 31, borderRadius: 6, selectedStyle: styles.selectedSmall },
} as const

interface BrandChipProps {
  imageSrc?: string
  imageAlt: string
  size?: keyof typeof sizeMap
  selected?: boolean
  badge?: ReactNode
  onClick?: () => void
}

export const BrandChip = (props: BrandChipProps) => {
  const { imageSrc, imageAlt, size = 'medium', selected, badge, onClick } = props
  const { width, height, imageWidth, imageHeight, borderRadius, selectedStyle } = sizeMap[size]

  return (
    <ButtonBase
      backgroundColor={colors.white}
      height={height}
      width={width}
      flexShrink={0}
      display="flex"
      borderRadius={borderRadius}
      rootStyle={[styles.root, selected && selectedStyle]}
      aria-pressed={selected ?? false}
      disableRipple
      onClick={onClick}
    >
      <Image src={imageSrc} alt={imageAlt} width={imageWidth} height={imageHeight} />
      {badge}
    </ButtonBase>
  )
}
